import React from "react";
import { FaDownload } from "react-icons/fa";

export default function EmpPayslips() {
  const payslips = [
    { month: "January", year: 2025, netSalary: "₹45,000" },
    { month: "December", year: 2024, netSalary: "₹44,500" },
    { month: "November", year: 2024, netSalary: "₹44,000" },
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">Payslips</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {payslips.map((payslip, idx) => (
          <div
            key={idx}
            className="bg-gradient-to-r from-purple-500 to-indigo-500 text-white rounded-2xl shadow-lg p-6 flex flex-col justify-between transform hover:scale-105 transition-transform cursor-pointer"
          >
            <div>
              <h3 className="text-xl font-bold">{payslip.month} {payslip.year}</h3>
              <p className="mt-2 text-gray-200">Net Salary: {payslip.netSalary}</p>
            </div>
            <button className="mt-4 bg-white text-indigo-600 font-semibold py-2 px-4 rounded-lg flex items-center justify-center space-x-2 hover:bg-gray-100 transition-all">
              <FaDownload />
              <span>Download</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
